import styled from 'styled-components'
import posed from 'react-pose'
import { Row, Col } from 'react-styled-flexboxgrid'
import variables from '../../styles/variables'
import { Heading, Button } from '..'
import { TextWrapper } from '../../styles/base'
import { headerStyles } from '../../styles/global'

export const Container = styled(TextWrapper)`
  width: 100%;
  background: ${variables.colors.silverTree.darker};
  padding: 70px 15px !important;
  color: white;
  position: relative;
  @media ${variables.media.sm} {
    padding: 70px 40px !important;
  }
  @media ${variables.media.md} {
    padding: 70px 180px !important;
  }
`

export const Header = styled(Heading)`
  ${headerStyles.headerSmall}
  font-family: ${variables.fonts.body};
  font-weight: 400;
  text-align: center;
  margin-bottom: 40px;
  @media ${variables.media.sm} {
    margin-bottom: 120px;
  }
`

export const SliderRow = styled(Row)`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 20px;
  @media ${variables.media.sm} {
    margin-bottom: 80px;
  }
`

export const FirstSliderRow = styled(SliderRow)`
  margin-bottom: 20px;
  @media ${variables.media.sm} {
    margin-bottom: 60px;
  }
`

export const SliderCol = styled(Col)`
  position: relative;
  margin: 40px 0;
`

export const FirstCol = styled(Col)`
  text-align: center;
  @media ${variables.media.sm} {
    text-align: right;
    padding-right: 50px;
  }
`
export const PricingComponentLabel = styled.p`
  margin: 0;
  /* position text to the same line as slider track */
  position: relative;
  top: -0.8rem;
`
export const DataAmountSlider = styled.div`
  width: 100%;
`
export const SliderLabels = styled.ul`
  list-style: none;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  position: relative;
  width: 100%;
  font-size: 0.7rem;
  top: 10px;
  @media ${variables.media.md} {
    font-size:  0.8rem;
  }
`

export const SliderLabel = styled.div`
  position: absolute;
  transform: translateX(-50%);

  ${props => `
    left: ${props.left};
  `}
`

export const SliderLabelActiveToggler = styled.p`
  opacity: 0.4;
  transition: opacity 0.3s ease;
  margin: 0;
  padding: 0;
  text-align: center;
  white-space: nowrap;

  ${props => props.active && `
    opacity: 1;
  `}
`

export const SliderLabelRange = styled(SliderLabelActiveToggler)`
  color: white;
  font-size: 0.7rem;
  margin-bottom: 4px;

  @media ${variables.media.sm} {
    font-size:  0.93rem;
  }
`

export const SliderLabelRangePrice = styled(SliderLabelActiveToggler)`
  color: ${variables.colors.silverTree.medium};
`

export const SliderLabelRangePlus = styled(SliderLabelActiveToggler)`
  opacity: 0;
  position: absolute;
  font-size: 17px;
  color: ${variables.colors.silverTree.light};
  transform: translate(-50%, 12px) scale(0.1);
  transition: opacity 0.3s ease, transform 0.2s ease;

  ${props => `
    left: ${props.left};
  `}

  ${props => props.active && `
    opacity: 1;
    transform: translate(-50%, 12px) scale(1);
  `}
`

export const QueriesContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
`

export const QueriesSlider = styled.div`
  width: 100%;
`

export const PriceContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
`

export const Price = styled.p`
  position: relative;
  width: 100%;
  font-size: 2rem;
  font-weight: 700;

  @media ${variables.media.sm} {
    font-size: 4rem;
  }
`

export const PriceSlot = styled.span`
  display: inline-block;
  min-height: 40px;
  white-space: nowrap;
`

export const ContactButton = styled(Button)`
  margin: 0;
`

export const PricePerPeriod = styled.span`
  width: 100%;
  font-size: 2rem;
  font-weight: 700;
`

export const PriceExplanation = styled.span`
  position: absolute;
  font-size: 0.8rem;
  bottom: -60px;
  font-weight: 400;
  left: 3px;
  color: ${variables.colors.silverTree.medium};
  margin: 20px 0;

  @media ${variables.media.md} {
    bottom: -60px;
  }
`

const PosedPriceNumber = posed.span({
  enter: {
    y: 0,
    opacity: 1,
    transition: {
      y: { duration: 300 },
      opacity: { duration: 200 },
    },
  },
  exit: {
    y: -20,
    opacity: 0,
    transition: {
      y: { duration: 300 },
      opacity: { duration: 200 },
    },
  }
})

export const PriceNumber = styled(PosedPriceNumber)`
  display: block;
`

const PosedContactLink = posed.a({
  enter: {
    y: 0,
    opacity: 1,
    transition: {
      y: { duration: 300 },
      opacity: { duration: 200 },
    },
  },
  exit: {
    y: 20,
    opacity: 0,
    transition: {
      y: { duration: 300 },
      opacity: { duration: 200 },
    },
  }
})

export const ContactLink = styled(PosedContactLink)`
  display: block;
`
